export default "__VITE_ASSET___TV6G0HV__"